const speechurl = "https://solaris.octavcodrea.com/speech.mp3";
const bgurl = "https://solaris.octavcodrea.com/backgroundsound.mp3";

export { speechurl, bgurl };